import PropTypes from 'prop-types';
import {useEffect} from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// hooks
import {useResponsive} from 'src/hooks/use-responsive';
// components
import Logo from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';
import {usePathname} from 'src/routes/hooks';
import {NavSectionVertical} from 'src/components/nav-section';
//
import {NAV} from '../config-layout';
import {useNavData, useSubNavData} from './config-navigation';
import {NavToggleButton, NavUpgrade} from '../_common';
import Version from 'src/components/version';
import {alpha, Button, Typography} from '@mui/material';

// ----------------------------------------------------------------------

export default function NavVertical({openNav, onCloseNav, onOpenShowConnectModal, isDemo}) {

  const pathname = usePathname();

  const lgUp = useResponsive('up', 'lg');

  const navData = useNavData();
  const subNavData = useSubNavData()

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        direction='row'
        alignItems='center'
        justifyContent="space-between"
        sx={{
          p: 2,
          mb: 2.5,
          background: '#F9FAFB',
          borderBottom: '1px solid #CDD5DC',
        }}
      >
        <Logo type='fullLogo' />
        <NavToggleButton />
      </Stack>

      <NavSectionVertical
        data={navData}
      />

      <Box sx={{flexGrow: 1}} />

      <NavSectionVertical
        data={subNavData}
      />
      {isDemo && (
        <>
          <Box sx={{flexGrow: 1}} />
          <Stack sx={{
            backgroundColor: '#212B36',
            padding: '16px',
            margin: '16px',
            borderRadius: '16px',
          }}>
            <Typography sx={{color: '#fff', mb: 1.5}} variant='caption' as='div'>
              Система предоставляется с ограниченными функциональными возможностями. Подключите полную версию
            </Typography>

            <Button
              fullWidth
              color="info"
              variant="contained"
              size="large"
              sx={[
                {
                  '&:hover': {
                    backgroundColor: (theme) =>
                      alpha(theme.palette.grey[500], 1),
                  },
                },
              ]}
              onClick={onOpenShowConnectModal}
            >
              Подключить
            </Button>
          </Stack>
        </>
      )}
      <Version alignItems="left"></Version>

      <NavUpgrade />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: {lg: 0},
        width: {lg: NAV.W_VERTICAL},
      }}
    >

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            background: '#fff'
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
              '& .MuiBox-root': {
                display: "flex",
                flexDirection: "column"
              }
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

NavVertical.propTypes = {
  onCloseNav: PropTypes.func,
  openNav: PropTypes.bool,
};
